import { koComponent } from '../../ko-utils';

class EditorIframePositionBar {
    constructor(params) {
        this.isMinimized = ko.observable(false);

        this.position = ko.observable();

        this.setPosition(localStorage.getItem('pf_designer_positioning') || 'right');

        this.notifyIframe();

        this.defaultizedChoices = ko.computed(() => {
            return window.topToolbarButtons.filter(i => i != null).map(i => {
                if (!i.title) i.title = '';
                if (!i.visible) i.visible = true;
                if (!i.html) i.html = '';
                if (!i.css) i.css = '';

                if (i.subActions) i.type = 'group';
                else if (i.text) i.type = 'normal';
                else if (!i.text) i.type = 'icon';

                return i;
            });
        })

        window.addEventListener('message', (msg) => {
            if (msg.data.action == 'force_iframe_position') {
                this.setPosition(msg.data.position);
            } else if (msg.data.action == 'toggle_iframe_position') {
                if (this.position() == 'left')
                    this.setPosition('right');
                else
                    this.setPosition('left');
            }
        });
    }

    notifyIframe() {
        window.parent.postMessage({ action: 'setIframePosition', position: this.position() }, '*');
    }

    setPosition(pos) {
        this.position(pos);

        if (pos === 'right') {
            document.body.classList.add('iframe-position-right');
        } else {
            document.body.classList.remove('iframe-position-right');
        }

        localStorage.setItem('pf_designer_positioning', pos);
        this.notifyIframe();
    }

    toggleIframeState() {
        if (this.isMinimized()) {
            window.parent.postMessage({ action: 'maximizeIframe' }, '*');
        } else {
            window.parent.postMessage({ action: 'minimizeIframe' }, '*');
        }

        this.isMinimized(!this.isMinimized());
    }
}

export default koComponent('editor-iframe-position-bar', EditorIframePositionBar);